/**
 * 员工派单开关
 */

import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 员工派单开关-开启或关闭接单开关
export const batchSelfAssignSwitchApi = (data?: any) =>
  request.post('/crm/staffAssignSwitchConfig/batchSelfOpenAssignSwitch', data, jsonHeaderConfig)
// 员工派单开关-列表查询
export const getSwitchConfigListApi = (data?: any, headers: any = undefined) => {
  // let headersConfig = jsonHeaderConfig
  // if(headers){
  //   headersConfig = { headers: Object.assign(headersConfig.headers, headers) }
  // }
  return request.post(
    '/crm/staffAssignSwitchConfig/selectList',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig
  )
}
// 员工派单开关-开启或关闭派单开关
export const batchUpdateAssignSwitchApi = (data?: any) =>
  request.post('/crm/staffAssignSwitchConfig/batchAssignSwitch', data, jsonHeaderConfig)
// CRM菜单-员工派单开关-开启或关闭派单开关
export const assignSwitchApi = (status: number) =>
  request.get(`/crm/staffAssignSwitchConfig/assignSwitch/${status}`, {})
// 员工派单开关-获取详情
export const assignSwitchConfigDetailApi = (data?: any) =>
  request.post('/crm/staffAssignSwitchConfig/queryDetail', data)
// 员工派单开关-详情-状态修改
export const updateDetailStatusApi = (data?: any) =>
  request.post('/crm/staffAssignSwitchConfig/updateStatus', data, jsonHeaderConfig)
// 获取当前登录者员工派单信息
export const queryByUserIdApi = (data?: any) =>
  request.post('/crm/staffAssignSwitchConfig/queryByUserId', data, jsonHeaderConfig)
